import { render } from "./StudentContainerView.vue?vue&type=template&id=4adf3702&ts=true"
import script from "./StudentContainerView.vue?vue&type=script&lang=ts"
export * from "./StudentContainerView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__